export const ADMINISTRADOR = 'Administrador';
export const CONSUMIDOR_FINAL = "Consumidor final";
export const MINORISTA = "Minorista";

export const ADMINISTRADOR_ID = 1;
export const CONSUMIDOR_FINAL_ID = 2;
export const MINORISTA_ID = 3;

